import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { FilteredOrganization, UserData } from 'src/app/reservation/reservation.model';
import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { BagPaymentListService } from '../../../bag-payment-list.service';
import { ContactDestiny } from 'src/app/common/enums/ContactDestiny';

enum CustomerType {
	PRIVATE = 0,
	COMPANY = 1,
}

@Component({
	selector: 'app-bag-payment-list-profile-add',
	templateUrl: './bag-payment-list-profile-add.component.html',
	styleUrls: ['./bag-payment-list-profile-add.component.scss'],
})
export class BagPaymentListProfileAddComponent {
	customerType = CustomerType;
	selectedCustomerType = CustomerType.PRIVATE;
	filteredOrganizations: FilteredOrganization[];
	filteredUsers: UserData[];
	payment;

	selectedUser: number = null;

	data = {
		ownerUser: false,
		ownerOrganization: null,
		documentType: null,
		documentNumber: null,
		birth: null,
		profile: {
			sex: null,
			first_name: null,
			last_name: null,
			nationality: null,
		},
		userContact: {
			phone: null,
			email: null,
			destiny: {
				destiny: ContactDestiny.CONTACT,
			},
		},
	};
	constructor(
		public dialogRef: MatDialogRef<BagPaymentListProfileAddComponent>,
		protected api: Data2Service,
		protected bag: DataBagService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected question: QuestionService,
		protected loader: LoaderService,
		protected _service: BagPaymentListService,
	) {}

	protected cancel(): void {
		this.dialogRef.close();
	}

	changeDocumentType({ value }: MatSelectChange) {
		if (value === null) this.data.documentNumber = null;
	}

	submit() {
		if (!this.data.profile.sex) return this.infobox.error('Uzupełnij zwrot grzecznościowy');
		if (!this.data.profile.first_name) return this.infobox.error('Uzupełnij imię');
		if (!this.data.profile.last_name) return this.infobox.error('Uzupełnij nazwisko');
		this.loader.show();
		const passport_number = this.data.documentType === 1 ? this.data.documentNumber : null;
		const id_number = this.data.documentType === 0 ? this.data.documentNumber : null;
		const birth = this.apiToDateTime(this.data.birth).date;
		const payload = {
			...this.data.profile,
			userContact: this.data.userContact,
			passport_number,
			id_number,
			birth,
		};
		this.send(payload);
	}

	protected send(payload): void {
		this.bag.post('/profile/data/', payload, (result, error) => {
			let err;
			if (error) {
				for (const key in error.error) {
					err += 'Field: ' + key + ' ' + error.error[key][0] + '</br>';
				}
				this.loader.hide();
				return;
			}
			this.loader.show();
			this._service.loadUsers(() => {
				this.dialogRef.close();
				this.loader.hide();
				return true;
			});
			return result;
		});
	}

	apiToDateTime(apiDate: string) {
		if (!apiDate) {
			return {
				date: null,
				time: null,
			};
		}
		const date = new Date(apiDate);
		const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
		return {
			date: dateString.slice(0, 10),
		};
	}

	changeSelectedData(value: boolean) {
		this.filteredUsers = [];
		this.filteredOrganizations = [];

		if (value) this.data.ownerOrganization = null;
		else this.selectedUser = null;
	}
}
